"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupByAccountAndTax = groupByAccountAndTax;
const money_1 = require("../money");
/**
 * يجمع مبالغ السطور بالحساب كما كانت القيود تفعل، لكن يفصل ما يحمل أثرًا ضريبيًا
 * بقاعدته وإصدارها: سطر صفرى أو معفى أو خارج النطاق لا ينتج سطر ضريبة، وضريبة غير قابلة
 * للخصم تُحمَّل على حساب سطرها — فلو ذابت فى المجموع لضاع الوعاء من الدفتر ولم يعد
 * إقرار القيمة المضافة قابلاً للبناء من السطور المنشورة وحدها. الأرصدة لا تتغير، فقط
 * سطر الحساب قد ينقسم إلى سطرين.
 *
 * أثر السطور المجمَّعة بقاعدة واحدة: الوعاء مجموع الأوعية والضريبة مجموع الضرائب.
 */
function groupByAccountAndTax(entries) {
    const groups = new Map();
    for (const entry of entries) {
        const key = entry.tax
            ? entry.account + '|' + entry.tax.ruleId + '|' + entry.tax.ruleVersion
            : entry.account + '|';
        const existing = groups.get(key);
        if (!existing) {
            groups.set(key, { account: entry.account, amount: entry.amount, tax: entry.tax });
            continue;
        }
        existing.amount = existing.amount.add(entry.amount);
        if (existing.tax && entry.tax) {
            existing.tax = {
                ...existing.tax,
                base: money_1.Money.of(existing.tax.base).add(entry.tax.base).toString(),
                amount: money_1.Money.of(existing.tax.amount).add(entry.tax.amount).toString(),
            };
        }
    }
    return [...groups.values()];
}
//# sourceMappingURL=line-tax.js.map